export default function () {
  const widgetName = 'hotButtons';
  // eslint-disable-next-line no-undef
  const widgetOpts = hotButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    cardWidgetLoaded: function () {
      // arguments: data, owl, hasData
      $(`#${widgetName} .card-widget-item.void-link`).removeAttr('href');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    moreButton: {
      visible: false,
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
